// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2a-Aj","inner":"Form_inner__2NPhG","range":"Form_range__3WZXP","name":"Form_name__3d2Wf","actions":"Form_actions__AJc_u"};